import init from './thing'

const organization =
{
    ...init
};

export default organization ;
